import Vue from "vue";
import Vuex from "vuex";

import global from "./global.module";

import auth from "./auth.module";
import dashboard from "./dashboard.module";
import search from "./search.module";
import label from "./label.module";
import note from "./note.module";
import subnote from "./subnote.module";

import monitors from "./monitors.module";

import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

const vuexPersisted = new createPersistedState({
  key: 'appVuex',
  storage: window.localStorage,
  reducer (val) {
    if(val.auth.isAuthenticated === false) {
      return {}
    }
    return val
  }
});

export default new Vuex.Store({
  modules: {
    global,
    auth,
    dashboard,
    search,
    label,
    note,
    subnote,
    monitors
  },
  plugins: [vuexPersisted]
});